import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.scss';
import App from './App.tsx';
import { ErrorBoundary } from '@sentry/react';
import { IS_SENTRY_DISABLED, SENTRY_DSN } from '@config/config.ts';
import { initSentry } from './libs/sentry.tsx';
import { initPostHog } from './libs/posthog.ts';
import { capturePromoterCode } from '@utils/promoterCode';
import { captureUtmParams } from '@utils/utmParams';
import { captureAttributionParams } from '@utils/attributionParams';
import { stashPendingDashboardParams } from '@utils/dashboardShareLink';
import AppCrashFallback from '@components/AppCrashFallback';

const isSentryDisabled = IS_SENTRY_DISABLED?.toLowerCase() === 'true';
initSentry(SENTRY_DSN, isSentryDisabled);

initPostHog();
capturePromoterCode();
captureUtmParams();
captureAttributionParams();
// Grab a dashboard share link here, at module load, before React mounts — the
// auth gate's redirect to /auth/login strips the query before any effect runs.
stashPendingDashboardParams();

// Render the app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {!isSentryDisabled ? (
      <ErrorBoundary fallback={<AppCrashFallback />}>
        <App />
      </ErrorBoundary>
    ) : (
      <App />
    )}
  </StrictMode>,
);
